import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { TextInput  } from '../components/forms/index'
import Button from '@atlaskit/button'

const UserCheckForm = (props) => {
    let { handleSubmit, actionInProgress } = props
    return (
        <form onSubmit={handleSubmit}>
            <div className='access-user-check-container'>
                <Field                     
                    key='UserId'
                    name='UserId'
                    component={TextInput}            
                    label='Nike Username or Email address'
                    title="Enter a Nike (NTID) username or email address to check a user's BAAT application access status.
                    
                    A Nike Username is the short name you use to login to your laptop"
                    placeholder='Nike Username or Email address'
                    disabled={actionInProgress}
                    className='pt4-sm ncss-input pr4-sm pb2-sm pl4-sm'/>            
                <Button type='submit' appearance='primary' isLoading={actionInProgress} className='search-form-btn'>
                    <i className='g72 g72-search' /> Search
                </Button>
            </div>
        </form>
    )
}

const validate = (values) => {
     return !values.UserId ? 'You need to enter Nike username or Email address to check' : undefined
    }
  
export default reduxForm({
    form: 'UserCheck',    
    validate: validate,    
})(UserCheckForm)



// WEBPACK FOOTER //
// ./client/src/accessSelfService/userCheckForm.js